import { render, staticRenderFns } from "./DeliveryNoteObject.vue?vue&type=template&id=42e3b60a&lang=pug&"
import script from "./DeliveryNoteObject.vue?vue&type=script&lang=ts&"
export * from "./DeliveryNoteObject.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryNoteObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports